// extracted by mini-css-extract-plugin
module.exports = {"responsiveFlex":"QuestionLayoutSkeleton_responsiveFlex__EADYX"};